import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Options} from './options/options';
import {Board} from './board/board';
import {HttpClient} from '@angular/common/http';
import {SoundEffects} from '../verliba-shared/src/sound-effects';
import {GengineClient, GameComponent} from '../verliba-shared';
import {IRoomData, IWorldData, MultiSnake} from './multi-snake';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild(GameComponent)
  game: GameComponent;

  wasInited = false;

  options = new Options();
  board: Board;
  sounds = new SoundEffects();

  client = new GengineClient<IWorldData, IRoomData>();
  multi: MultiSnake;

  constructor(private httpClient: HttpClient, private elRef: ElementRef<HTMLDivElement>) {
    this.board = new Board(this.httpClient, this.options);
    this.board.levels.load(this.httpClient).catch();
    this.multi = new MultiSnake(this.client, this.board);
  }

  ngOnInit(): void {
    this.board.events.subscribe((event) => this.sounds.play(event));
  }

  onOptionsLoaded(): void {
    if (this.options.remote){
      this.multi.engage();
    }
    this.board.restart().catch();
  }

  onOptionsChange(): void {
    this.elRef.nativeElement.blur();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.wasInited = true, 100);
  }
}
